import React from "react";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { NotificationConfigurationModel } from "../../../../../../Wrap/Models/Domains/Threads/NotificationConfigurationModel";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { NotificationAction } from "../../Action/NotificationAction";
import { EmailNotification } from "./EmailNotification";
import { ExistingNotifications } from "./ExistingNotifications";
import { NewNotification } from "./NewNotification";

interface INotificationConfigurationsProps {
    onCancel: () => void;
    onApply: (v) => void;
}

interface INotificationConfigurationsState {
    isLoading: boolean;
    hasFirmLevelPermission: boolean;
    model: NotificationConfigurationModel;
}

export class NotificationConfigurations extends FormComponent<
    INotificationConfigurationsProps,
    INotificationConfigurationsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,

            hasFirmLevelPermission: false,
            model: null,
        };
    }

    componentDidMount() {
        this.setState({
            isLoading: true,
            hasFirmLevelPermission: checkPermission(UserClaim.AdviserPortalFirmLevelNotificationReadWrite),
        });

        NotificationAction.getNotificationConfiguration((result) => {
            this.setState({ model: result, isLoading: false });
        });
    }

    private loadNotificationConfigurationModel() {
        this.setState({ isLoading: true });

        NotificationAction.getNotificationConfiguration((result) => {
            this.setState({ model: result, isLoading: false });
        });
    }

    public render(): JSX.Element {
        const { model, hasFirmLevelPermission, isLoading } = this.state;

        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        return (
            <div>
                <NewNotification
                    model={model}
                    hasFirmLevelPermission={hasFirmLevelPermission}
                    onSave={() => this.loadNotificationConfigurationModel()}
                />
                <hr />
                <ExistingNotifications
                    model={model}
                    hasFirmLevelPermission={hasFirmLevelPermission}
                    onSave={() => this.loadNotificationConfigurationModel()}
                />
                <hr />
                <EmailNotification
                    emailConfig={model?.EmailConfiguration}
                    onSave={() => this.loadNotificationConfigurationModel()}
                />
                <hr />
            </div>
        );
    }
}
